import { Subscription } from 'rxjs';

export interface IUploadProgress {
  fileName: string;
  progress: number;
  status: UploadStatus;
  subscription?: Subscription;
}

export enum UploadStatus {
  PENDING = 'pending',
  UPLOADING = 'uploading',
  COMPLETE = 'complete',
  ERROR = 'error',
  CANCELLED = 'cancelled'
}
